import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import TradeProfitLossChart from "../Charts/TradeProfitLossChart";
import TradeResultTable from "./TradeResultTable";
import CommonTable from "./CommonTable";
import { dollarUS } from "../../utilities/formatters";

const ResultsByTrade = ({ data }) => {
  // const dummyDta = [
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  // ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Duration",
        accessor: "Duration",
      },
      {
        Header: "No of Trades",
        accessor: "no_of_trade",
      },
      {
        Header: "Results",
        accessor: "results",
        Cell: ({ value }) => (
          <>
            <p
              className={`${
                value > 0 ? "profit_val" : value < 0 ? "loss_val" : ""
              }`}
            >
              {dollarUS(value)}
            </p>
          </>
        ),
      },
    ],
    []
  );

  return (
    <div className="ResultByClose">
      {/* <Grid className="longshort-inner" item xs={12} md={6}  sx={{ paddingLeft: { xs: 0 } }}>
        <Card className="card-csc" sx={{marginLeft:'15px'}}>
          <Title six>Profit in durations</Title>
          <TradeProfitLossChart data={data} />
        </Card>
      </Grid> */}
      {/* <Grid
        className="longshort-inner"
        item
        xs={12}
        md={6}
        sx={{ paddingLeft: { xs: 0 } }}
      > */}
      <Title six>Results by Days</Title>
      <Card className="card-csc" sx={{}}>
        <CommonTable data={data} columns={columns} />
      </Card>
      {/* </Grid> */}
    </div>
  );
};

export default ResultsByTrade;
